import { get, writable } from 'svelte/store';
import { navigate } from '../../../app.logic';
import { QualityWasteService } from '../../../services/quality-waste.service';
import { ReportService } from '../../../services/report-service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const uploading = writable(false);
export async function initList() {
    const date = new Date();
    filter.set({ criteria: { year: date.getFullYear() }, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    uploading.set(false);
    if (oid == 0) {
        //const date = new Date();
        record.set({
            oid: 0,
            documentDate: "",
            year: 0,
            month: 0,
            description: "",
            cat2Kg: 0.0,
            cat3Kg: 0.0,
            storedFileId: 0
        });
    }
    else {
        let _resp = await QualityWasteService.fetchQualityWaste(oid);
        record.set(_resp.payload);
    }
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await QualityWasteService.getQualityWastes(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    navigate(`/quality-waste/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/quality-waste/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await QualityWasteService.saveQualityWaste(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await QualityWasteService.deleteQualityWaste(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export async function downloadQualityWasteReport() {
    let _filter = get(filter);
    ReportService.exportPdfQualityWaste(_filter);
}
